const headRowsAreas = {
  actions: 'Actions',
  area: 'Department'
}

export default headRowsAreas;
